/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Debt_Bucket_0_30Inputs */

const vi_report_debt_bucket_0_30 = /** @type {(inputs: Report_Debt_Bucket_0_30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0 - 30 ngày`)
};

/**

* @param {Report_Debt_Bucket_0_30Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_debt_bucket_0_30 = /** @type {((inputs?: Report_Debt_Bucket_0_30Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Debt_Bucket_0_30Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_debt_bucket_0_30(inputs)
});